import React, { PureComponent } from 'react'
import Dropzone from 'react-dropzone'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Line } from 'rc-progress'
import { includes } from 'lodash'

import { MessageErrorInput } from 'Components/Message/Error/input'

import UploadIcon from 'Assets/Images/icons/upload'
import PaperClipIcon from 'Assets/Images/icons/paperClip'

import { getFilenameWithExtensionFromUrl, imageExtension } from 'Utils/Regexp'

class DropzoneUnstyled extends PureComponent {
  state = { files: [], percent: 0 }

  uploadIcon = (text, isReport, isFileSelect = false) => {
    const showFileIcon = isReport && isFileSelect

    return (
      <div>
        {!isReport && <UploadIcon />}
        <div
          className={classnames({
            'dropzone-text': isReport,
            'dropzone-text-active': showFileIcon,
          })}
        >
          {showFileIcon && <PaperClipIcon />}
          <span>
            {text && text.length > 10 ? text.slice(0, 10) + '...' : text}
          </span>
        </div>
      </div>
    )
  }

  renderUploadIcon = isReport => {
    const { dropzoneLabel = this.props.hint || 'Upload' } = this.props

    const Filepreview = ({ url, type, name = '', showImagePreview = true }) =>
      (includes(type, 'image') || name.match(imageExtension)) &&
      showImagePreview ? (
        <div
          className="file-preview"
          style={{ backgroundImage: `url(${url})` }}
        />
      ) : (
        this.uploadIcon(name, isReport, true)
      )

    if (!this.state.files.length && this.props.src) {
      const name = getFilenameWithExtensionFromUrl(this.props.src)
      const decodedName = decodeURIComponent(name)
      return (
        <Filepreview
          url={this.props.src}
          name={decodedName}
          showImagePreview={this.props.showImagePreview}
        />
      )
    }

    if (!this.state.files.length) {
      return this.uploadIcon(dropzoneLabel, isReport)
    }

    return this.state.files.map((file, i) => {
      const name = decodeURIComponent(file.name)
      return (
        <Filepreview
          key={i}
          url={file.preview}
          name={name}
          type={file.type}
          showImagePreview={this.props.showImagePreview}
        />
      )
    })
  }

  render = (props = this.props) => {
    const {
      accept,
      className,
      input,
      mainLabel,
      multiple = false,
      progress,
      disabled,
      onDropRejected,
      onError,
      innerRef = undefined,
      isReport = false,
      reportTypeSelected = true,
      disableClick = false,
    } = props
    let meta = props.meta || {}
    const errorJSX =
      props.error || (meta.touched && meta.error) ? (
        <MessageErrorInput message={meta.error || props.error} />
      ) : null

    return (
      <div className={className}>
        <label cypress_id={`${props.cypress_id}-label`}>{mainLabel}</label>
        <div className="dropzone-preview">
          <Dropzone
            accept={accept ? accept : ''}
            activeClassName="dropzoneActive"
            className="dropzone"
            multiple={multiple}
            onDrop={(files, ...rest) => {
              if (!files || !files.length) {
                this.setState({ files: [] })
                return
              }
              if (!isReport || reportTypeSelected) {
                this.setState({ files })
              }

              input.onChange(files, ...rest)
            }}
            disabled={disabled}
            cypress_id={`${props.cypress_id}-button`}
            ref={innerRef}
            disableClick={disableClick}
            onDropRejected={
              onDropRejected
                ? () => {
                    onDropRejected()
                    this.setState({ files: [] })
                  }
                : undefined
            }
            onError={onError}
          />
          {this.renderUploadIcon(isReport)}
        </div>
        {progress && (
          <Line
            percent={progress}
            strokeWidth="1"
            strokeColor="#2db7f5"
            strokeLinecap="square"
          />
        )}
        {errorJSX}
      </div>
    )
  }
}

DropzoneUnstyled.propTypes = {
  dropzoneLabel: PropTypes.string,
  mainLabel: PropTypes.string,
  multiple: PropTypes.bool,
}

export { DropzoneUnstyled }
